.spacedout {
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.6px;
}
